import React, { useEffect, useState, useContext } from "react";
import { Box, Container, Grid } from "@mui/material";
import { AuthContext } from "../../contexts/AuthContext";
import ProfileHeader from "../../components/Settings/Profile/ProfileHeader";
import ProfileInfo from "../../components/Settings/Profile/ProfileInfo";
import ProfileStats from "../../components/Settings/Profile/ProfileStats";
import EditProfileDialog from "../../components/Settings/Profile/EditProfileDialog";
import { useErrorDialog } from "../../contexts/ErrorDialogContext";
import { useSuccessDialog } from "../../contexts/SuccessDialogContext";
import ComponentLoading from "../../components/App/ComponentLoading";

const ProfilePage = ({ onGoToBilling }) => {
  const { global_authState, getUserData, updateUserProfile, getOrganization } =
    useContext(AuthContext);
  const [userData, setUserData] = useState({});
  const [organization, setOrganization] = useState({});
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleError = useErrorDialog();
  const handleSuccess = useSuccessDialog();

  const fetchUserData = async () => {
    if (global_authState?.uid) {
      try {
        setLoading(true);
        const data = await getUserData(global_authState.uid);

        const getOrg = await getOrganization();
        const org = getOrg?.organization ?? null;
        setOrganization(org);

        setUserData(data);
      } catch (error) {
        console.error("Error fetching user data:", error);
        handleError("Failed to load user data. Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [global_authState?.uid]);

  const handleEditProfile = () => {
    setEditDialogOpen(true);
  };

  const handleCloseEditDialog = () => {
    setEditDialogOpen(false);
  };

  const handleGoToBilling = () => {
    if (onGoToBilling) {
      onGoToBilling();
    }
  };

  const handleUserProfileUpdate = async (values) => {
    try {
      await updateUserProfile(values);
      handleSuccess("Successfully updated your profile.");

      handleCloseEditDialog();
      fetchUserData();
    } catch (error) {
      handleError(error);
    }
  };

  if (loading) {
    return <ComponentLoading />;
  }

  return (
    <Box
      sx={{
        width: "100%",
        overflow: "auto",
        bgcolor: "background.default",
        py: { xs: 2, sm: 3 },
      }}
    >
      <Container maxWidth='lg'>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={8}>
            <ProfileHeader user={userData} onEditProfile={handleEditProfile} />
            <Box sx={{ mt: 3 }}>
              <ProfileInfo user={userData} goToBilling={handleGoToBilling} />
            </Box>
          </Grid>

          <Grid item xs={12} lg={4}>
            <ProfileStats user={userData} organization={organization} />
          </Grid>
        </Grid>
      </Container>

      {/* Edit Profile Dialog */}
      <EditProfileDialog
        open={editDialogOpen}
        onClose={handleCloseEditDialog}
        user={userData}
        onUpdate={handleUserProfileUpdate}
      />
    </Box>
  );
};

export default ProfilePage;
